module.exports = __webpack_public_path__ + "img/statistics-manage.b09f4b7d.svg";